<cloud-devices-grid (onShowCertificates)="onShowCertificates($event)"></cloud-devices-grid>

<mat-expansion-panel [hidden]="!selectedDevice" [expanded]="expandList">
  <mat-expansion-panel-header>
    <mat-panel-title>{{'deviceTexts.certsToDevice' | translate}}{{selectedDevice?.name}}</mat-panel-title>
  </mat-expansion-panel-header>
  <cloud-manage-grid isSubcomponent="true"></cloud-manage-grid>
</mat-expansion-panel>